import type {ClientList} from "../../../types/clients.types";

import {deleteClient} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {clientKeys, clientMutationKeys} from "../../../client-keys";

export function deleteClientMutationOptions() {
  const listFilter = {queryKey: clientKeys.lists()};

  return mutationOptions({
    mutationFn: (id: string) => deleteClient(id),
    mutationKey: clientMutationKeys.deleteClient,
    onMutate: async (deletedId, {client}) => {
      await client.cancelQueries(listFilter);
      const previousLists = client.getQueriesData<ClientList>(listFilter);

      client.setQueriesData<ClientList>(listFilter, (old) => {
        if (!old) return old;

        return {
          ...old,
          items: old.items.filter((item) => item.clientId !== deletedId),
          meta: {...old.meta, total: Math.max(0, old.meta.total - 1)},
        };
      });

      return {previousLists};
    },
    onError: (_error, _deletedId, context, {client}) => {
      context?.previousLists.forEach(([key, snapshot]) => client.setQueryData(key, snapshot));
    },
    onSuccess: async (_data, deletedId, _context, {client}) => {
      client.removeQueries({queryKey: clientKeys.detail(deletedId)});
      await client.invalidateQueries(listFilter);
    },
  });
}
